import React, { useState } from "react";
import axios from "../../axios-backend";
import BackButton from "../main/BackButton";
import Button from "../main/Button";
import Line from "../main/Line";
import { useLocation } from "react-router-dom";

const AdTypeVideo = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const [gender, setGender] = useState("");
  const [video, setVideo] = useState('');

  const handleGenderChange = (e) => {
    setGender(e.target.value);
    axios
      .get("/get-type-video", {
        params: {
          id: id,
          gender: e.target.value,
        },
      })
      .then((data) => {
        if (!data) {
          return;
        } else {
          setVideo(data.data.video.videoUrl);
        }
      });
  };

  const handleSaveNew = () => {
    const params = { pId: id, url: video, gender };
    axios.post("/upload-type-video-new", params).then(data => {
      if (data.data.status === 200) {
        alert('done')
      }
    });
  }

  return (
    <div style={{ height: "100%" }}>
      <BackButton />
      <Line type="bottom-line">
        This is a page for adding videos. if you add a unisex video, it will be
        displayed on both women and men sides
      </Line>
      <Line type="bottom-line">
        <select
          value={gender}
          onChange={(e) => {
            handleGenderChange(e);
          }}
        >
          <option>Please Select Gender</option>
          <option value="1">Collection video - Men</option>
          <option value="0">Collection video - Women</option>
          <option value="2">Collection video - Unisex</option>
          <option value="11">Men's video - How to measure Men</option>
          <option value="00">Women's video - How to measure Women</option>
          <option value="22">Unisex's video - How to Measure Unisex</option>
          <option value="111">Mens' Meaning Video</option>
          <option value="000">Womens' Meaning Video</option>
        </select>
      </Line>

      {/* //#region
      {!currentVideo ? (
        <>
          <Line type="bottom-line">
            <input
              type="file"
              accept="video/*"
              onChange={handleChangeVideo}
              name="file"
              multiple
            />
          </Line>
          <Line type="bottom-line">
            <Button
              onClick={(e) => {
                gender === ""
                  ? window.alert("please select gender")
                  : handleSave();
              }}
            >
              Upload{" "}
            </Button>
          </Line>
        </>
      ) : (
        <Line type="bottom-line">
          <Button onClick={(e) => handleDelete()}>Delete Video</Button>
        </Line>
      )}
      //#endregion */}
      <Line type="bottom-line">
        Note: Copy and paste the url of the collection video that you uploaded to Wistia
      </Line>
      <Line type="bottom-line">
        <label>Wistia Link: </label>
        <input
          type="text"
          value={video}
          style={{ width: "20rem" }}
          onChange={(e) => {
            setVideo(e.target.value);
          }}
        />
      </Line>
      <Line type="bottom-line">
        <Button
          onClick={(e) => {
            gender === ""
              ? window.alert("please select gender")
              : handleSaveNew();
          }}
        >
          Upload
        </Button>
      </Line>
    </div>
  );
};

export default AdTypeVideo;
